export enum EmailColumnsEnum {
  Select = 'select',
  ArchiveStatus = 'archiveStatus',
  Starred = 'starred',
  Reply = 'reply',
  Attachment = 'attachment',
  From = 'from',
  To = 'to',
  Subject = 'subject',
  Size = 'size',
  Date = 'date',
  Source = 'source',
  State = 'state',
  Meta = 'meta',
  Notes = 'notes',
  Folder = 'folder',
}
